import { capitalizeEachWord } from "~/utils/strings";

type CountryData = {
  alpha2code: string;
  name: string;
};

export const buildCountryCodeToNameMap = (
  countries: CountryData[] | undefined,
): Record<string, string> => {
  const map: Record<string, string> = {};
  countries?.forEach((country) => {
    if (country.alpha2code) {
      map[country.alpha2code] = capitalizeEachWord(country.name);
    }
  });
  return map;
};
